export const convertDateRanges = (ranges) => {
    const { endDate, startDate } = ranges;

    return {
        ...ranges,
        endDate: new Date(endDate),
        startDate: new Date(startDate),
    };
};

export const newRanges = (ranges) => {
    const { date, comparisonDate } = ranges;
    return {
        ranges: {
            date: date && convertDateRanges(date),
            comparisonDate: comparisonDate && convertDateRanges(comparisonDate),
        },
    };
};
